module.exports = __webpack_public_path__ + "static/relationships-c84c8750897ce1f18382d50277b21d58.jpg";